import { Component, OnInit } from '@angular/core';
import { NeproseService } from 'src/app/services/neprose.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from 'src/app/components/confirmation-box/confirmation-box.component';

@Component({
  selector: 'app-published-property',
  templateUrl: './published-property.component.html',
  styleUrls: ['./published-property.component.css']
})
export class PublishedPropertyComponent implements OnInit {

  dataLoaded: boolean

  propertyList = []

  municipalityList = []

  adPlans = []

  constructor( private _neproseService: NeproseService, private route: ActivatedRoute, private _router: Router, private _notification: MatSnackBar, private dialog: MatDialog ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: { municipalityList: any, adPlans: any})=> {
      this.municipalityList = data.municipalityList.municipalities
      this.adPlans = data.adPlans
    })
    this.getPropertyList()
  }

  getPropertyList(){
    this._neproseService.getMyProperties().subscribe(data => {
      this.dataLoaded = true
      if(data.propertyAd){
        let propertyList = data.propertyAd
        for(let property of propertyList){
          if(property.status == 'completed' || property.status == 'sold'){
            property['featuredImage'] = null
            if(property.PropertyImage){
              let propertyImages = JSON.parse(property.PropertyImage.imagePath)
              if(propertyImages.length > 0){
                property.featuredImage = environment.api+'/images/'+propertyImages[0]
              }
            }
            let municipality = this.municipalityList.find(municipality => municipality.id == property.municipality_id)
            let address = municipality.municipality
            if(property.village){
              address = property.village+', '+address
            }
            property['address'] = address
            let plan = this.adPlans.find(adPlan => adPlan.id == property.ad_plan_id)
            if(plan){
              property['expiryDate'] = this.addDays(property['approvalDate'], plan.validityDays).slice(0, 10)
            }
            this.propertyList.push(property)
          }
        }
      }
    })
  }

  addDays(approvalDate, days){
    var date = new Date(approvalDate)
    date.setDate(date.getDate() + days)
    return date.toISOString()
  }

  changeStatusToSold(property){
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        text: 'Are you sure you want to change the Property status to Sold?'
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this._neproseService.updatePropertyStatusToSold(property.id).subscribe(data => {
          if(data.status){
            property.status = 'sold'
            this.openNotification('Property Status set to Sold')
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  changeStatusToCompleted(property){
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        text: 'Are you sure you want to change the Property status back to Published?'
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this._neproseService.updatePropertyStatusToCompleted(property.id).subscribe(data => {
          if(data.status){
            property.status = 'completed'
            this.openNotification('Property Status set to Published')
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  openNotification(msg){
    this._notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  viewProperty(id){
    this._router.navigate(['/property/'+id])
  }

  editProperty(id){
    this._router.navigate(['/edit-property/'+id])
  }

}